<template>
  <div>
    <div class="overlay" @click.prevent="closeSpin"></div>
    <div class="modal_fixed">
      <div class="new_achievement_box modal_cont" id="wheel_prize_modal">
        <img src="static/images/store/icon-close-back-popup.svg" class="btn_close" @click="closeSpin">
        <h1>{{ getTranslations.home_modals_notifications_spin_wheel_congratulation }}</h1>
        <p>{{ getTranslations.home_modals_notifications_spin_wheel_you_unlocked }}</p>
        <div id="wrapper">

          <div id="wheel">
            <div id="inner-wheel" :class="[disableDuration ? 'noSpin' : 'spinNormal']">
              <div class="sec"><span class="fa"><img src="static/images/achievements/spin-prize.svg"></span></div>
              <div class="sec"><span class="fa"><img src="static/images/achievements/spin-prize.svg"></span></div>
              <div class="sec"><span class="fa"><img src="static/images/achievements/spin-prize.svg"></span></div>
              <div class="sec"><span class="fa"><img src="static/images/achievements/spin-prize.svg"></span></div>
              <div class="sec"><span class="fa"><img src="static/images/achievements/spin-prize.svg"></span></div>
              <div class="sec"><span class="fa"><img src="static/images/achievements/spin-prize.svg"></span></div>
            </div>
            <div id="spin">
              <img src="static/images/achievements/drop_inabox.svg" id="">
            </div>
            <div id="shine"></div>
          </div>

        </div>
        <button class="claim_prize" id="spin_wheel"
                v-if="!hasMadeASpin"
                @click.prevent="spin()">{{ getTranslations.home_modals_notifications_spin_wheel_spin }}
        </button>

        <div class="spinning_wheel prize" v-else-if="determineResult() && hasMadeASpin">
          <div class="bounce_box bounce_animation">
            <img class="icon" src="static/images/bonus_points.svg" alt="">
          </div>
          <a style="cursor: pointer"
             @click.prevent="claimPrize()"
             class="btn2 btn2_modal btn2--std btn2--small">
            {{ getTranslations.home_modals_notifications_spin_wheel_see }}
          </a>
        </div>
        <span v-show="showResult && !determineResult() && hasMadeASpin">
       {{ getTranslations.home_modals_notifications_spin_wheel_you_lost }}
      </span>
      </div>
    </div>
    <div class="circle_background popup_circle_bg"></div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { spinTheWheel } from '@/common/jQuery';

// achievements_modal_wheel
export default {
  name: 'spin-wheel',
  data() {
    return {
      numOfClicks: 0,
      degree: 1800,
      result: '',
      hasMadeASpin: false,
      clicked: false,
      disableDuration: false,
      normalDurationPassed: false,
      haveRewardResponse: false,
      showResult: false,
      watchModal: false,
    };
  },
  created() {
    // if it is notification -> checkedNotificationId and already seen
    if (this.checkedNotificationId && this.checkedNotificationReadStatus) {
      this.setDisableDuration();
      const spinPosition = this.calculateResult();
      this.$nextTick(() => { spinTheWheel(this.numOfClicks, this.degree, spinPosition); });
      this.hasMadeASpin = true;
      this.clicked = true;
      this.prizeName = this.notificationRewardName;
      this.result = this.notificationPrizeWon ? 'WIN' : 'LOSE';
      this.showResult = true;
      this.clearData();
    }
  },
  methods: {
    ...mapActions('profile', [
      'sendNotificationReward',
    ]),
    ...mapMutations('profile', [
      'setNotificationRewardId',
      'setCheckedNotificationId',
      'setCheckedNotificationReadStatus',
      'setNotificationRewardName',
      'setNotificationPrizeWon',
      'setRedeemedNotification',
    ]),
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    closeSpin() {
      this.setRedeemed();
      this.$emit('close');
    },
    claimPrize() {
      this.$emit('openNewModal', this.prizeName);
    },
    determineResult() {
      switch (this.result) {
      case 'WIN': return true;
      case 'LOSE':
      default: return false;
      }
    },
    initSpinCounter() {
      setTimeout(this.setDuration, 4000); // do action after 4 seconds passed (minimum spin wheel duration)
    },
    setDuration() {
      this.normalDurationPassed = true;
      if (this.haveRewardResponse) {
        this.showResult = true;
        this.hasMadeASpin = true;
      }
    },
    setDisableDuration() {
      this.disableDuration = true;
    },
    calculateResult() {
      return this.notificationPrizeWon ? this.getRewardId() : 5; // 5: try again state
    },
    getRewardId() {
      return parseInt(this.notificationRewardName.substr(this.notificationRewardName.indexOf('.') + 1), 10) + 1;
    },
    setRedeemed() {
      // set activeNotification in vuex as read
      // not necessary for BRAINIAC projects
      this.setRedeemedNotification(this.checkedNotificationId);
      this.$emit('read', this.checkedNotificationId);
    },
    clearData() {
      // clear from vuex data
      this.setNotificationRewardId({ value: '' });
      this.setCheckedNotificationId({ value: '' });
      this.setNotificationRewardName({ value: '' });
      this.setNotificationPrizeWon({ value: false });
      this.setCheckedNotificationReadStatus({ value: false });
    },
    spin() {
      if (!this.clicked && !this.hasMadeASpin) {
        this.clicked = true;
        this.initSpinCounter();
        const notificationId = this.notificationRewardId ? '' : this.checkedNotificationId;
        // checks if already has been redeemed
        this.sendNotificationReward({ reward: this.notificationRewardId, notif: notificationId }).then((response) => {
          this.haveRewardResponse = true;
          if (this.normalDurationPassed) {
            this.showResult = true;
          }
          this.result = JSON.parse(response.data.data).result;
          if (this.result) {
            this.prizeName = JSON.parse(response.data.data).prize || this.notificationRewardName;
            this.setRedeemed();
          }
          this.clearData();
        }).catch((error) => {
          // eslint-disable-next-line
          console.log('error while redeem reward: ' + error);
          this.setDisableDuration();
          this.showResult = true;
          this.hasMadeASpin = true;
          this.setRedeemed();
          spinTheWheel(this.numOfClicks, this.degree, 2); // spin the wheel to "try again" state
        });
        spinTheWheel(this.numOfClicks, this.degree, this.calculateResult());
      }
    },
  },
  computed: {
    modalForHome() {
      return this.modalForHomePage;
    },
    ...mapState('common', [
      'modalForHomePage',
    ]),
    ...mapState('profile', [
      'checkedNotificationId',
      'checkedNotificationReadStatus',
      'notificationRewardId',
      'notificationRewardName',
      'notificationPrizeWon',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>


<style scoped>
  .noSpin{
    width:100%;
    height:100%;
    -webkit-transition: all 0s cubic-bezier(0,.99,.44,.99) !important;
    -moz-transition:    all 0 cubic-bezier(0,.99,.44,.99) !important;
    -o-transition:      all 0s cubic-bezier(0,.99,.44,.99) !important;
    -ms-transition:     all 0s cubic-bezier(0,.99,.44,.99) !important;
    transition:         all 0s cubic-bezier(0,.99,.44,.99) !important;
  }
  .spinNormal{
    width:100%;
    height:100%;
    -webkit-transition: all 4s cubic-bezier(0,.99,.44,.99) !important;
    -moz-transition:    all 4 cubic-bezier(0,.99,.44,.99) !important;
    -o-transition:      all 4s cubic-bezier(0,.99,.44,.99) !important;
    -ms-transition:     all 4s cubic-bezier(0,.99,.44,.99) !important;
    transition:         all 4s cubic-bezier(0,.99,.44,.99) !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/modals/spinwheel/SpinWheel.vue